var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResizeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FEBE4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.334 33H18.334C16.6771 33 15.334 31.6569 15.334 30V18C15.334 16.3432 16.6771 15 18.334 15H30.334C31.9909 15 33.334 16.3432 33.334 18V30C33.334 31.6569 31.9909 33 30.334 33ZM29.334 20.4142L24.7482 25H26.334C26.8863 25 27.334 25.4477 27.334 26C27.334 26.5523 26.8863 27 26.334 27H22.334C21.7817 27 21.334 26.5523 21.334 26V22C21.334 21.4477 21.7817 21 22.334 21C22.8863 21 23.334 21.4477 23.334 22V23.5858L27.9198 19H26.334C25.7817 19 25.334 18.5523 25.334 18C25.334 17.4477 25.7817 17 26.334 17H30.334C30.8863 17 31.334 17.4477 31.334 18V22C31.334 22.5523 30.8863 23 30.334 23C29.7817 23 29.334 22.5523 29.334 22V20.4142Z",
    fill: "#0E0C15"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIcon);
export default __webpack_public_path__ + "static/media/resizeIcon.8bc196d2fb533a1441821de7e3c97752.svg";
export { ForwardRef as ReactComponent };